import React from 'react';
import RegisterForm from "../components/User/RegisterForm";

const Register = () => {
    return (
        <div className = "w-screen h-screen">
            <RegisterForm />
        </div>
    );
};

export default Register;